/**
 * Firebase Loader for Topics
 * Henter topic data fra Firebase Firestore i stedet for JSON filer
 */

import { 
  getFirestore, 
  doc, 
  getDoc 
} from 'firebase/firestore'
import { db } from '../../config/firebase'

let indexCache = null

/**
 * Load index from Firebase
 */
export async function loadIndexFromFirebase() {
  if (indexCache) {
    return indexCache
  }
  
  try {
    const indexDoc = await getDoc(doc(db, 'topics_index', 'current'))
    
    if (!indexDoc.exists()) {
      throw new Error('topics_index/current not found in Firebase')
    }
    
    const data = indexDoc.data()
    indexCache = data
    console.log('✅ Loaded topics_index from Firebase')
    return data
  } catch (error) {
    console.error('Error loading index from Firebase:', error)
    throw error
  }
}

/**
 * Load topic data from Firebase
 */
export async function loadTopicFromFirebase(topicId) {
  try {
    const topicDoc = await getDoc(doc(db, 'topics_data', topicId))
    
    if (!topicDoc.exists()) {
      throw new Error(`Topic ${topicId} not found in Firebase`)
    }
    
    const data = topicDoc.data()
    // Remove Firebase metadata
    const { lastUpdated, ...topicData } = data
    console.log(`✅ Loaded ${topicId} from Firebase`)
    return topicData
  } catch (error) {
    console.error(`Error loading topic ${topicId} from Firebase:`, error)
    throw error
  }
}

/**
 * Clear cache (useful for testing)
 */
export function clearIndexCache() {
  indexCache = null
}
